import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Segment, Label, List } from 'semantic-ui-react';
import BEMHelper from 'react-bem-helper';
import * as userActions from '../../Actions/actions_user';
import * as billingActions from '../../Actions/actions_billing';
import { gaEvent, gaTransaction } from '../../utils/gtm';
import './SubscriptionPlan.scss';
import { setSignupActive } from '../../Actions';
import { nextQuestion } from '../../Actions/actions_register';
import { TrackEvent } from '../../Services/TrackEvent';

const bem = BEMHelper({ name: 'SubscriptionPlan', outputIsString: true });

function getMonthlyPrice(price, period, period_unit) {
  let priceInDollars = price / 100;

  if (period_unit === 'month') priceInDollars = priceInDollars / period;

  if (period_unit === 'year') priceInDollars = priceInDollars / 12;

  // const hasCents = price % 100 > 0;
  // const formattedPrice = priceInDollars.toLocaleString('en-US', {
  //   style: 'currency',
  //   currency: 'USD',
  // });

  // const priceValue = hasCents ? formattedPrice : formattedPrice.slice(0, -3);
  return priceInDollars;
}

class SubscriptionPlan extends Component {
  constructor(props) {
    super(props);
    this.choosePlan = this.choosePlan.bind(this);
  }

  choosePlan(plan, that) {
    if (window.Chargebee) {
      const cbInstance = window.Chargebee.getInstance();
      cbInstance.openCheckout({
        async hostedPage() {
          const data = await that.props.createHostedCheckout(plan.id);
          return data.message;
        },
        async success(hostedPageId, data) {
          const invoice = data && data.invoice;
          if (invoice) {
            gaTransaction({
              transactionId: invoice.id,
              transactionTotal: invoice.total / 100,
              transactionProducts: [
                {
                  sku: plan.id,
                  name: plan.name,
                  price: invoice.total / 100,
                  quantity: 1,
                },
              ],
            });
          } else {
            gaEvent({
              category: 'engagement',
              action: 'generate_lead',
            });
          }
          await that.props.fetchUserSubscription(that.props.user.pk, {
            update: true,
          });
          cbInstance.closeAll();
          that.props.assignPlanId(plan.id);
          that.props.nextQuestion();
        },
        loaded() {
          gaEvent({
            category: 'ecommerce',
            action: 'begin_checkout',
          });
        },
        step(page) {
          gaEvent({
            category: 'cb-checkout',
            action: page,
          });
        },
      });
    } else {
      console.warn('Error loading Chargebee');
    }
  }

  getBilledAt(period, period_unit, totalPrice) {
    let period_text = '';

    if (period_unit === 'month' && period === 6)
      period_text = `bi-annually at ${totalPrice}`;
    else if (period_unit === 'month') period_text = 'monthly';
    else if (period_unit === 'year') period_text = `yearly at ${totalPrice}`;
    else return '';

    return `Billed ${period_text}`;
  }

  render() {
    const totalPrice = this.props.price / 100;

    const monthlyPrice = getMonthlyPrice(
      this.props.price,
      this.props.period,
      this.props.period_unit
    );
    const period_unit = this.props.period_unit;
    const period = this.props.period;
    const color = this.props.color || 'blue';

    return (
      <div className={cx(bem('', `color-${color}`))}>
        <Segment.Group className="SubscriptionPlan__card" raised>
          <Segment className={bem('name')} textAlign="center">
            {this.props.name}
          </Segment>
          <Segment className={bem('pricing')} textAlign="center">
            <div className={cx(bem('annual-price'), 'flex')}>
              <span className={bem('annual-price-int')}>
                {Math.floor(monthlyPrice)}
              </span>
              <div className="flex flex-col justify-between mb-3">
                <span className={bem('annual-price-dec')}>
                  {((monthlyPrice % 1) * 100).toFixed(0)}
                </span>
                <span>/month</span>
              </div>
            </div>

            <p className={bem('monthly')}>
              {this.getBilledAt(period, period_unit, totalPrice)}
            </p>
          </Segment>

          <Segment className="SubscriptionPlan__cta-wrapper" textAlign="center">
            <div>
              <div className="flex flex-col items-center">
                <Button
                  className="SubscriptionPlan__cta"
                  onClick={() => {
                    const that = this;
                    this.choosePlan(
                      {
                        name: this.props.campaign_name,
                        id: this.props.payment_id,
                      },
                      that
                    );
                    TrackEvent(`subscription-click-${this.props.payment_id}`);
                  }}
                  inverted={!this.props.recommended}
                >
                  Subscribe to {this.props.name}
                </Button>
              </div>
            </div>
          </Segment>
        </Segment.Group>
      </div>
    );
  }
}

SubscriptionPlan.propTypes = {
  name: PropTypes.string,
  monthlyPrice: PropTypes.number,
  annualPrice: PropTypes.number,
  description: PropTypes.string,
  trialPeriod: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
  color: PropTypes.string,
  monthlyPlanName: PropTypes.string,
  annualPlanName: PropTypes.string,
  fetchUserSubscription: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
  recommended: PropTypes.bool,
  history: PropTypes.shape(),
  onClickMonthly: PropTypes.func,
  onClickSubscribe: PropTypes.func,
  createHostedCheckout: PropTypes.func,
  nextQuestion: PropTypes.func,
  assignPlanId: PropTypes.func,
};

const mapStateToProps = () => ({});

export default withRouter(
  connect(mapStateToProps, {
    fetchUserSubscription: userActions.fetchUserSubscription,
    createHostedCheckout: billingActions.createHostedCheckout,
  })(SubscriptionPlan)
);
